import {
  arrayOf,
  bool,
  func,
  number,
  oneOfType,
  shape,
  string,
} from "prop-types";

export const articleType = shape({
  body: arrayOf(shape()),
  createdAt: string,
  id: string,
  image: oneOfType([
    shape({
      url: string,
    }),
    string,
  ]),
  title: string,
  type: string,
  updatedAt: string,
});

export const partnerType = shape({
  body: arrayOf(shape),
  categories: arrayOf(
    shape({
      slug: string,
      title: string,
    }),
  ),
  description: string,
  id: string,
  logo: string,
  metaDescription: string,
  metaTitle: string,
  prisjaktId: number,
  slug: string,
  title: string,
  trackingUrl: string,
});

export const prisjaktProductType = shape({
  description: shape,
  external_uri: string,
  id: number,
  url: string,
  price: shape({
    compare: number,
    diff_percentage: number,
    id: number,
    offer: number,
  }),
  product: shape({
    id: number,
    name: string,
    price: shape({
      count: number,
    }),
    media: shape({
      product_images: shape({
        first: shape({
          140: string,
          280: string,
          800: string,
        }),
        count: number,
      }),
    }),
    uri: string,
  }),
  store: shape({
    name: string,
    logo: shape({
      88: string,
      176: string,
    }),
  }),
}).isRequired;

export const promotionType = shape({
  discount: string,
  id: string,
  image: shape({
    _type: string,
    asset: shape({
      _ref: string,
      _type: string,
    }),
  }),
  partner: shape({
    _id: string,
    logo: string,
    slug: string,
    title: string,
  }),
  stickyLive: bool,
  title: string,
  trackingUrl: string,
});

export const siteConfigType = shape({
  footerLinksFirst: arrayOf(
    shape({
      _key: string,
      _type: string,
      href: string,
      title: string,
    }),
  ),
  footerLinksSecond: arrayOf(
    shape({
      _key: string,
      _type: string,
      href: string,
      title: string,
    }),
  ),
  footerText: arrayOf(
    shape({
      _key: string,
      _type: string,
      children: oneOfType([
        arrayOf(
          shape({
            _type: string.isRequired,
          }),
        ),
        shape({
          _type: string.isRequired,
        }),
      ]).isRequired,
      markDefs: arrayOf(
        shape({
          _type: string.isRequired,
        }),
      ),
      style: string,
    }),
  ),
  metaDescription: string,
  metaTitle: string,
});
